import { BroadcastChannelMap } from "helpers/hooks/useBroadcastChannel";
import { createContext } from "react";

export enum SessionChangedMessage {
  LOGGED_OUT = "logged-out",
  LOGGED_IN = "logged-in",
}

export const BroadcastChannelContext = createContext<BroadcastChannelMap>(null!);
